import { createSelector } from 'reselect';
import { getAvatar } from './EntitySelector';
import { getEmailHashFromCurrentUserProfile } from './ProfileSelector';
import AvatarAPI from '../api/AvatarAPI';
export const getAvatarUpdatedAt = createSelector([getAvatar], avatar => avatar.get('updatedAt'));
export const getAvatarUrl = createSelector([getEmailHashFromCurrentUserProfile, getAvatarUpdatedAt], (emailHash, updatedAt) => {
  return AvatarAPI.getAvatarUrl(emailHash, {
    updatedAt
  });
});